<template>
	<div class="upload-image" ref="uploadImage">
		<div
        class="image-input"
        :style="{ 'background-image': `url(${imageData})` }"
		@click="chooseImage"
		>
			<span v-if="!imageData" class="placeholder" >
				<SvgIcon class="gallery-input__placeholder-icon" iconName="ico-img"/>
			</span>
			<a class="btn upload-img-btn" @click="trigger">
				<SvgIcon class="upload-iimage-icon-plus" iconName="ico-plus"/>
				Add Image
			</a>
			<input
				class="file-input"
				ref="fileInput"
				type="file"
				@input="onSelectFile"
				@dragover="dragover"
				accept=".jpg, .jpeg, .png"
				@change="imgFormat"
				id="fileName"
			>
		</div>
		<a class="btn upload-image__btn" @click="chooseImage">Change Image</a>
		<a class="upload-image__delete" @click="deleteImage">
			<SvgIcon class="upload-image__delete-icon" iconName="ico-close-sm"/>
		</a>
		<span class="upload-image__tooltip">{{ message }}
			<span class="arrow-angle"></span>
		</span>
		<div class="notification-upload">
			<PartNotifications ref="SupportedFormat" v-if="showError" :data="DataSupportedFormat"/>
		</div>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartNotifications from '@/components/parts/PartNotifications';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			imageData: null,
			showError: false,
			fileInputClass: 'file-input',
			message: 'Supported image formats: jpg, jpeg, png!',
			DataSupportedFormat: {
				type: 'danger',
				msg: 'Only jpg/jpeg and png files are allowed!'
			},
			isFormatAccepted: false
		};
	},
	components: {
		SvgIcon,
		PartNotifications
	},
	watch: {
		imageData() {
			this.$emit('input', this.imageData);

			if (this.imageData) {
				this.$refs.uploadImage.classList.add('show__btn');
			} else {
				this.$refs.uploadImage.classList.remove('show__btn');
			}
		}
	},
	methods: {
		resizeImage(base64Str, maxWidth = 400, maxHeight = 350) {
			if (this.byteCount(base64Str) < 5000000) {
				return new Promise((resolve) => {
					resolve(base64Str);
				});
			}
			return new Promise((resolve) => {
				const img = new Image();
				img.src = base64Str;
				img.onload = () => {
					const canvas = document.createElement('canvas');
					const MAX_WIDTH = maxWidth;
					const MAX_HEIGHT = maxHeight;
					let width = img.width;
					let height = img.height;

					if (width > height) {
						if (width > MAX_WIDTH) {
							height *= MAX_WIDTH / width;
							width = MAX_WIDTH;
						}
					} else {
						if (height > MAX_HEIGHT) {
							width *= MAX_HEIGHT / height;
							height = MAX_HEIGHT;
						}
					}
					canvas.width = width;
					canvas.height = height;
					const ctx = canvas.getContext('2d');
					ctx.drawImage(img, 0, 0, width, height);
					resolve(canvas.toDataURL());
				};
			});
		},
		byteCount(string) {
			return (encodeURI(string).split(/%..|./).length - 1) / 1.37;
		},
		imgFormat() {
			const fileName = document.getElementById('fileName').value;
			const idxDot = fileName.lastIndexOf('.') + 1;
			const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
			if (!(extFile === 'jpg' || extFile === 'jpeg' || extFile === 'png')) {
				this.showError = true;
				this.isFormatAccepted = true;

				setTimeout(() => {
					this.showError = false;
				}, 2000);
			}
		},
		chooseImage (event) {
			event.target.value = '';
		},
		dragover(event) {
			event.preventDefault();
		},
		onSelectFile () {
			const input = this.$refs.fileInput;
			const files = input.files;
			const self = this;
			if (files && files[0]) {
				const reader = new FileReader();
				reader.onload = e => {
					if (this.isFormatAccepted === false) {
						self.resizeImage(e.target.result).then(function(image) {
							self.imageData = image;
						});
						// this.imageData = e.target.result;
						this.$refs.uploadImage.classList.add('show__btn');
					}
				};
				reader.readAsDataURL(files[0]);
			}
		},
		deleteImage() {
			this.imageData = '';
			this.$refs.uploadImage.classList.remove('show__btn');
		},
		trigger () {
			this.$refs.fileInput.click();
		},
		setValue(value) {
			this.imageData = value;
		}
	}
};
</script>

<style lang="scss" scoped>
.upload-image__tooltip {
	position: absolute;
	bottom: -43px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    font-size: 12px;
	background-color: $grey-light;
	border-radius: 8px;
	padding: 5px;
	opacity: 0;
	visibility: hidden;
	transition: all 0.75s ease;
	font-family: $font-main;
	line-height: 1.2;
	text-align: center;
	max-width: 150px;
	color: $fiord;

	@include mq($xl) {
		opacity: 1;
		visibility: visible;
	}
}

.arrow-angle {
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 10px 10px 10px;
	border-color: transparent transparent #ebecf0 transparent;
	top: -10px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

	@include mq($xl) {
		display: none;
	}
}

.upload-image {
	position: relative;
	display: block;
    width: 150px;
    height: 150px;
    cursor: pointer;

	@include hover {
		.upload-image__tooltip {
			opacity: 1;
			visibility: visible;
		}
	}

	&.show__btn {
		@include hover {
			.image-input {
				-webkit-filter: blur(1px); /* Chrome, Safari, Opera */
				filter: blur(1px);
			}
			.upload-image__btn,
			.upload-image__delete {
				opacity: 1;
				visibility: visible;
				z-index: 1;
			}

			.upload-image__btn {
				background-color: $white;
				color: $dodger-blue;
			}
		}

		.upload-img-btn {
			opacity: 0;
			display: none;
		}

		@include mq(1250px) {
			.upload-image__btn,
			.upload-image__delete {
				opacity: 1;
				visibility: visible;
				z-index: 1;
			}
		}
	}

}

.upload-iimage-icon-plus {
	font-size: 12px;
    margin-right: 10px;
    display: inline-block;
}

.image-input {
    display: block;
    width: 150px;
    height: 150px;
    cursor: pointer;
    background-size: contain;
	background-repeat: no-repeat;
    background-position: center center;
	position: relative;
	border: 2px dashed $slate-gray;
	border-radius: 8px;
}

.placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 50px;
	transition: $dur $ease;

	.gallery-input__placeholder-icon {
		color: $grey-light;
		transition: $dur $ease;
	}

	@include hover {
		background-color: $grey-light;
		.gallery-input__placeholder-icon {
			color: $white;
		}
	}
}

.file-input {
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    left: 0;
    right: 0;
	cursor: pointer;
}

.upload-image__btn {
	max-width: 90%;
	left: 50%;
	bottom: 5px;
	transform: translateX(-50%);
	position: absolute;
	opacity: 0;
	visibility: hidden;
	transition: $dur $ease;
	pointer-events: none;
}

.upload-image__delete {
	opacity: 0;
	visibility: hidden;
	border: none;
	background: none;
	position: absolute;
	transition: $dur $ease;
	right: -3px;
	top: 0;
	cursor: pointer;
	color: $fiord;
	z-index: 3;

	@include hover {
		color: $dodger-blue;
	}
}

.upload-img-btn {
	max-width: 90%;
	left: 50%;
	bottom: 5px;
	transform: translateX(-50%);
	position: absolute;
	transition: $dur $ease;
	z-index: 3;
}

.upload-image__delete-icon {
	background-color: $white;
    border-radius: 50%;
    padding: 4px;
}

</style>
